import styled from 'styled-components';
import { PrimaryButton as PrimaryButtonBase } from '../../style';

export const WidePrimaryButton = styled(PrimaryButtonBase)`
    width: auto !important;
    min-height: 40px;
    margin-top: 10px;
`;
